import { useState } from "react";

import DocumentsTable from "./DocumentsTable";
import DocumentDelete from "./DocumentDelete";
import { DocumentIcon } from "@heroicons/react/24/outline";
import DocumentPromptEdit from "./DocumentPromptEdit";

export default function Documents(props) {
  const { documents, onDocumentDelete, onDocumentPromptUpdate, showActions } = props;

  const [openDelete, setOpenDelete] = useState({
    isOpen: false,
    document: null,
  });

  const [openEdit, setOpenEdit] = useState({
    isOpen: false,
    document: null,
  });

  if (!Boolean(documents.length)) {
    return (
      <div className="border rounded-lg h-80 flex items-center justify-center">
        <div className="flex flex-col items-center gap-y-2">
          <DocumentIcon className="size-12 text-gray-600" />
          <p className="text-sm font-light text-gray-500">
            No Reference Documents
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="h-[62dvh] overflow-scroll">
        <DocumentsTable
          documents={documents}
          onDeleteClick={(document) =>
            setOpenDelete({ isOpen: true, document })
          }
          onEditClick={(document) => {
            setOpenEdit({ isOpen: true, document });
          }}
          showActions={showActions}
        />
      </div>
      {openDelete.isOpen && (
        <DocumentDelete
          open={openDelete.isOpen}
          onClose={() => setOpenDelete({ isOpen: false, document: null })}
          document={openDelete.document}
          onDocumentDelete={onDocumentDelete}
        />
      )}
      {openEdit.isOpen && (
        <DocumentPromptEdit
          open={openEdit.isOpen}
          onClose={() =>
            setOpenEdit({ isOpen: false, document: null })
          }
          document={openEdit.document}
          onDocumentPromptUpdate={onDocumentPromptUpdate}
        />
      )}
    </>
  );
}
